/**
 * Environment banner — a thin, always-visible bar at the top of every page
 * that makes it impossible to mistake DEV for PROD (or vice versa).
 *
 * Behaviour:
 *   REACT_APP_APP_ENV=dev   → blue bar reading "ADVOSET DEV"
 *   REACT_APP_APP_ENV=prod  → green bar reading "ADVOSET PROD"
 *   REACT_APP_APP_ENV=<any> → grey bar showing the raw value
 *   unset                   → hidden (safe default so preview URLs stay clean)
 *
 * The banner also shows the app version from shared/version.js so a quick
 * glance tells you exactly what's deployed.
 */
import React from "react";
import { APP_VERSION } from "@shared/version";

const ENV_CONFIG = {
  dev: {
    label: "ADVOSET DEV",
    bg: "#1D4ED8",   // blue-700 — unmistakably dev
    fg: "#FFFFFF",
    testid: "env-banner-dev",
  },
  prod: {
    label: "ADVOSET PROD",
    bg: "#15803D",   // green-700 — production
    fg: "#FFFFFF",
    testid: "env-banner-prod",
  },
  preprod: {
    label: "ADVOSET PREPROD",
    bg: "#B45309",   // amber-700 — warning tone
    fg: "#FFFFFF",
    testid: "env-banner-preprod",
  },
};

export default function EnvironmentBanner() {
  const env = (process.env.REACT_APP_APP_ENV || "").toLowerCase();
  if (!env) return null;
  const cfg = ENV_CONFIG[env] || {
    label: `ADVOSET ${env.toUpperCase()}`,
    bg: "#475569",
    fg: "#FFFFFF",
    testid: `env-banner-${env}`,
  };
  return (
    <div
      data-testid={cfg.testid}
      style={{
        backgroundColor: cfg.bg,
        color: cfg.fg,
        padding: "4px 12px",
        fontSize: "11px",
        fontWeight: 800,
        letterSpacing: "0.15em",
        textAlign: "center",
        fontFamily: "'Poppins', system-ui, sans-serif",
        borderBottom: `1px solid rgba(0,0,0,0.15)`,
        userSelect: "none",
      }}
    >
      <span>{cfg.label}</span>
      <span style={{ opacity: 0.75, marginLeft: 12, fontWeight: 500 }}>
        v{APP_VERSION}
      </span>
    </div>
  );
}
